import { useEffect, useState } from "react";
import { useConnectivity } from "../../../../shell-handle/ShellHostProvider";

const REPROBE_MS = 15_000;

export function useOnlineStatus(enabled: boolean) {
  const connectivity = useConnectivity();
  const [online, setOnline] = useState(() => connectivity?.isOnline() ?? true);

  useEffect(() => {
    if (!enabled || !connectivity) return;
    const unsubscribe = connectivity.onChange(setOnline);
    void connectivity.probe().then(() => setOnline(connectivity.isOnline()));
    const timer = setInterval(() => void connectivity.probe(true), REPROBE_MS);
    return () => {
      clearInterval(timer);
      unsubscribe();
    };
  }, [enabled, connectivity]);

  const probeOnline = () => connectivity?.probe() ?? Promise.resolve(true);

  return { online, probeOnline };
}
